<template>

    <SubHeader title="Fiche agent" :breads="[{ name: 'Créer Agent' }]" :action="{}" />
    <div class="row">
        <div class="col-md-12">
            <form @submit.prevent="handleSubmit(data)" >

                <div class="row">
                    <div class="col-md-6">
                        <div class="card">

                            <div class="card-header card-header-content-md-between">
                                <h3 class="card-header-title">Détails</h3>
                                <small class="text-muted">Saisie des informations</small>
                            </div>
                            <div class="card-body">
                                <div class="mb-3">
                                    <label class="form-label" for="firstname">Prénom(s)</label>
                                    <input type="text" name="firstname" id="firstname" class="form-control"
                                        placeholder="Prénom(s)" v-model="data.firstname" value="">
                                </div>
                                <div class="mb-3">
                                    <label class="form-label" for="lastname">Nom</label>
                                    <input type="text" name="lastname" id="lastname" class="form-control"
                                        placeholder="Nom" v-model="data.lastname" value="">
                                </div>
                                <div class="mb-3">
                                    <label class="form-label" for="email">Email</label>
                                    <input type="text" name="email" v-model="data.email" id="email" class="form-control" placeholder="Email"
                                        value="">
                                </div>
                                <div class="mb-3">
                                    <label class="form-label" for="contact">Contact</label>
                                    <input type="text" name="contact" id="contact" class="form-control"
                                        placeholder="contact" v-model="data.contact" value="">
                                </div>
                                <div class="mb-3 tom-select-custom">
                                    <label class="form-label" for="service">Service</label>
                                    <m-select v-model="data.type" :loading="serviceIsLoading"  :required="true" :options="serviceItems" :searchable="false" 
                                        placeholder="Type de service" track-by="id" label="label" >
                                    </m-select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <br><br>
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-body">
                                <button type="submit" class="btn btn-primary">Enregistrer</button>&nbsp;
                                <button type="button" class="btn btn-danger" @click="this.$router.back()">Annuler</button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>
<script>

import SubHeader from "@/layouts/admin/SubHeader.vue"
import { mapActions } from "vuex";
import { mapFields } from "vuex-map-fields";

export default {
    name: "AdminConfigCreateAgent",
    components: {
        SubHeader
    },
    data(){
        return{
            data:{}
        }
    },
    computed: {
        ...mapFields("agent/create", {
            isLoading: "isLoading",
            isSuccess: "isSuccess",
            showMessage: "showMessage",
            message: "message",
            items: "items",
            isCreated:"isCreated"

        }),
        ...mapFields("service/list", {
            serviceIsLoading: "isLoading",
            serviceIsSuccess: "isSuccess",
            serviceShowMessage: "showMessage",
            serviceMessage: "message",
            serviceItems: "items"

        })
    },

    methods: {
        ...mapActions({
            handleSubmit: "agent/create/create",
            reset: "agent/create/resetData",
            resetService: "service/list/resetData",
            getServices: "service/list/getAll",
            
        })
    },
    watch:{
        "data.type"(val){
            if(val){
                this.data.recipientservice_id = val.id ?? null
            
            }
        },
        isCreated(val){
            if(val){
                this.$router.push({name:'AdminConfigAgent'})
            }
        }
    },

    unmounted() {
        this.reset()
        this.resetService()
    },
    mounted() {
        this.getServices()

    }
}
</script>
